import http from './http'
import { AxiosPromise } from 'axios'
import { AppApiResponseData } from '../types/api'
import { ScheduleCoachNameData } from '../types/schedule'
import { CoachDataRequest, Coach, CoachHistoryLogRequest } from '../types/coaches'
import { User } from '../types/user'

export function getCoachNames(): AxiosPromise<
	AppApiResponseData<Array<ScheduleCoachNameData>>
> {
	return http({
		method: 'GET',
		url: '/p/coach/names',
	})
}

export function getCoachesToAssign(
	data: CoachDataRequest
): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'POST',
		url: '/p/coach/search/assignPatientCoach',
		data,
	})
}

export function getCoaches(): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'POST',
		url: '/p/coach/search/coaches',
	})
}

export function getCoachData(
	timezoneOffsetInMinutes: number, id: string
): AxiosPromise<AppApiResponseData<Coach>> {
	return http({
		method: 'GET',
		url: `/p/user/${id}?timezone=${timezoneOffsetInMinutes}`,
	})
}

export function blockCoach(
	id: string
): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'POST',
		url: `/p/user/${id}/block`,
	})
}

export function unblockCoach(
	id: string
): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'POST',
		url: `/p/user/${id}/unblock`,
	})
}

export function getHistoryLogCoach(
	data: CoachHistoryLogRequest
): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'POST',
		url: `/p/auditTrail/search`,
		data
	})
}
export function updateOtherUsers(
	data: User
): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'PUT',
		url: `/p/update/otherUser`,
		data
	})
}
